import React, { Component } from 'react'
import {
    Link,
    Redirect
} from 'react-router-dom'
import { AppContext, Features } from '@lightspeed-invoicing/core-client/frontend'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import ConfirmButton from "../../common/button/confirmbutton.component.jsx"
import LoadingSpinner from '../../common/spinner/loading.component.jsx'

class OrderStatusEditForm extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            id: '',
            name: '',
            type: this.props.type || '',
            status: this.props.status || {},
            rank: this.props.rank || 0,
            formStatus: '',
            deleteButton: '',
            loading: false,
        }

        this.submit = this.submit.bind(this)
        this.handleFormChange = this.handleFormChange.bind(this)
        this.remove = this.remove.bind(this)
    }

    componentDidMount() {
        const status = this.props.status
        if (status && status.id) {
            this.loadStatus(status)
        }

    }

    loadStatus(status) {
        const deleteButton = <ConfirmButton identifier={status.attributes.name} onClick={this.remove} className="btn btn-danger">
            <FormattedMessage
                id="order_status.form.edit.delete_btn"
                defaultMessage="Delete order status"
            />
        </ConfirmButton>
        this.setState({
            id: status.id,
            name: status.attributes.name,
            type: status.attributes.type,
            status: status,
            deleteButton: deleteButton,
        })
    }

    remove(event) {
        AppContext.getApiClient().delete('/order-statuses/' + this.state.id).then(response => {
            if (!response.error) {
                this.setState({ formStatus: <Redirect to={{ pathname: '/order-statuses/listing' }} /> })
            }
        })
        event.preventDefault()
    }

    save() {
        if (this.state.status && this.state.id) {
            let updates = {}
            const allowedFields = [
                "name",
            ]
            for (let i = 0; i < allowedFields.length; i++) {
                let field = allowedFields[i]
                if (this.state.status.attributes[field] != this.state[field]) {
                    updates[field] = this.state[field]
                }
            }
            return AppContext.getApiClient().patch('/order-statuses/' + this.state.id, updates)
        } else {
            return AppContext.getApiClient().post('/order-statuses', {
                "name": this.state.name,
                "type": this.state.type,
                "rank": parseInt(this.state.rank),
            })
        }
    }

    submit(event) {
        event.preventDefault()
        this.save().then(response => {
            if (!response.error) {
                this.setState({ formStatus: <Redirect to={{ pathname: '/order-statuses/listing' }} /> })
            }
        })
        event.preventDefault()
    }

    handleFormChange(event) {
        const target = event.target;
        let value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    render() {
        if (this.state.loading) {
            return <LoadingSpinner />
        }

        const messages = defineMessages({
            "name_placeholder": {
                id: 'order_status.form.edit.name_placeholder',
                defaultMessage: 'Name of the order status',
            },
            "save_btn": {
                id: 'order_status.form.edit.save_btn',
                defaultMessage: 'Save the order status',
            },
        })

        return (
            <form onSubmit={this.submit}>
                <div className="row ui-has-modules">
                    <div className="col-12 ui-module">
                        <div className="form-group row mb-2">
                            <label className="col-2 col-form-label text-align-right" htmlFor="name">
                                <FormattedMessage
                                    id="order_status.form.edit.name_label"
                                    defaultMessage="Name"
                                />
                            </label>
                            <div className="col-10 mb-3">
                                <input
                                    name="name"
                                    value={this.state.name}
                                    onChange={this.handleFormChange}
                                    id="name"
                                    type="text"
                                    className="form-control"
                                    placeholder={this.props.intl.formatMessage(messages['name_placeholder'])}
                                />
                            </div>
                        </div>
                        <div className="form-group row mb-2">
                            <label className="col-2 col-form-label text-align-right" htmlFor="description">
                                <FormattedMessage
                                    id="order_status.form.edit.type"
                                    defaultMessage="Type"
                                />
                            </label>
                            <div className="col-10 mb-3">
                                {this.state.type === 'ordered' && <span className={'badge badge-warning'}>
                                    <FormattedMessage
                                        id="order_status.form.edit.type.ordered"
                                        defaultMessage="In Progress"
                                    />
                                </span>}
                                {this.state.type === 'completed' && <span className={'badge badge-success'}>
                                    <FormattedMessage
                                        id="order_status.form.edit.type.completed"
                                        defaultMessage="Completed"
                                    />
                                </span>}
                            </div>
                        </div>
                    </div>

                    <div className="col-12">
                        {this.state.formStatus}
                    </div>
                    {(!this.state.id || (this.state.id && !this.state.status.attributes.deletedBy)) &&
                        <div className="col-12 ui-module">
                            <div className="row">
                                <div className="col-6">
                                    {this.state.deleteButton}
                                </div>
                                <div className="col-6 text-align-right">
                                    <Link to="/order-statuses/listing" className="btn btn-light">
                                        <FormattedMessage
                                            id="payment_type.form.edit.cancel_btn"
                                            defaultMessage="Cancel"
                                        />
                                    </Link>
                                &nbsp;
                                &nbsp;
                                <input type="submit" value={this.props.intl.formatMessage(messages['save_btn'])} className="btn btn-primary" />
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </form>
        );
    }
}

export default injectIntl(OrderStatusEditForm)


// WEBPACK FOOTER //
// ./src/order-status/form/edit.component.jsx